const newModel = () => {
    return {
        phanloaiTruongMamnonId: null,
        ten: null,
        quymoTruongchuanId: null,
        tenQuymoTruongchuan: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        phanloaiTruongMamnonId: null,
        ten: null,
        quymoTruongchuanId: null,
        moTa: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        ten: item.ten,
        quymoTruongchuanId: item.quymoTruongchuanId,
        tenQuymoTruongchuan: item.tenQuymoTruongchuan,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        ten: item.ten,
        quymoTruongchuanId: item.quymoTruongchuanId,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        phanloaiTruongMamnonId: null,
        ten: null,
        quymoTruongchuanId: null,
        moTa: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        phanloaiTruongMamnonId: item.phanloaiTruongMamnonId,
        ten: item.ten,
        quymoTruongchuanId: item.quymoTruongchuanId,
        moTa: item.moTa,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        phanloaiTruongMamnonId: null,
        ten: null,
        quymoTruongchuanId: null,
        moTa: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null
    }
}

export const phanLoaiTruongMamNonGDModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


